import {
  GetCancerScreeningResultModel,
  GetCancerScreeningResultWithQueryModel,
} from "../models/getCancerScreeningResultModel";

import { CreateCancerScreeningAnalysisResultModel } from "../models/createAnalysisRequest";
import { GetCancerScreeningInfoModel } from "../models/getCancerScreeningInfoModel";
import { GetCancerScreeningsModel } from "../models/getCancerScreeningsModel";
import { GetCancerScreeningsResultModel } from "../models/getCancerScreeningsResultModel";
import { IGetCancerScreeningInfo } from "../interfaces/cancerScreeningRequest";
import { IHttpAnswer } from "../interfaces/httpAnswer";
import api from "../api";

/* eslint-disable */

/* eslint-enable */
export async function getCancerScreenings(
  getCancerScreeningsModel: GetCancerScreeningsModel
): Promise<IHttpAnswer<GetCancerScreeningsResultModel>> {
  const res = await api.post(
    `/CancerScreening/CancerScreeningsQuery`,
    getCancerScreeningsModel,
    true
  );
  return {
    data: new GetCancerScreeningsResultModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function getCancerScreening(
  id: string
): Promise<IHttpAnswer<GetCancerScreeningResultModel>> {
  const res = await api.get(
    `/CancerScreening/CancerScreeningQuery/${id}`,
    true
  );
  return {
    data: new GetCancerScreeningResultModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function getCancerScreeningWithQuery(
  id: string
): Promise<IHttpAnswer<GetCancerScreeningResultWithQueryModel>> {
  const res = await api.get(
    `/CancerScreening/CancerScreeningWithResultsQuery/${id}`,
    true
  );
  return {
    data: new GetCancerScreeningResultWithQueryModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function cancelCancerScreening(
  id: number,
  userSsn: string
): Promise<IHttpAnswer<undefined>> {
  const res = await api.delete(
    `/CancerScreening/CancelCancerScreening`,
    { id, userSsn },
    true
  );
  return {
    data: undefined,
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function completeCancerScreening(
  id: number,
  userSsn: string
): Promise<IHttpAnswer<undefined>> {
  const res = await api.post(
    `/CancerScreening/CompleteCancerScreening`,
    { id, userSsn },
    true
  );
  return {
    data: undefined,
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function createAnalysisRequest(
  id: number,
  userSsn: string,
  userName: string,
  originalUserSsn: string,
  analysisType: number
): Promise<IHttpAnswer<CreateCancerScreeningAnalysisResultModel>> {
  const res = await api.post(
    `/CancerScreening/CreateCancerScreeningAnalysis`,
    { id, userSsn, userName, originalUserSsn, screeningLabStatus: analysisType },
    true
  );
  return {
    data: new CreateCancerScreeningAnalysisResultModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function resendAnalysisRequest(
  id: number,
  userSsn: string,
  userName: string,
  originalUserSsn: string,
  analysisType: number
): Promise<IHttpAnswer<CreateCancerScreeningAnalysisResultModel>> {
  const res = await api.post(
    `/CancerScreening/ResendCancerScreeningAnalysis`,
    { id, userSsn, userName, originalUserSsn, screeningLabStatus: analysisType },
    true
  );
  return {
    data: new CreateCancerScreeningAnalysisResultModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function removeCancerScreeningTests(
  id: number,
  userSsn: string,
): Promise<IHttpAnswer<undefined>> {
  const res = await api.post(
    `/CancerScreening/RemoveCancerScreeningTests`,
    { id, userSsn },
    true
  );
  return {
    data: undefined,
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function getCancerScreeningInfo(
  payLoad: IGetCancerScreeningInfo
): Promise<IHttpAnswer<GetCancerScreeningInfoModel>> {
  const res = await api.post(
    `/CancerScreening/GetCancerScreeningInfo`,
    payLoad,
    true
  );
  return {
    data: new GetCancerScreeningInfoModel(res.data),
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}

export async function changeCancerScreeningStatus(
  id: number,
  userSsn: string,
  newStatus: number
): Promise<IHttpAnswer<undefined>> {
  const res = await api.post(
    `/CancerScreening/ChangeCancerScreeningStatus`,
    { id, userSsn, newStatus },
    true
  );
  return {
    data: undefined,
    isOk: res.isOk,
    statusCode: res.statusCode,
  };
}
